import { useQuery } from 'react-query'
import { fetchSchoolList } from '../pages/school/api'

const useSchool = () => {
  const { data, isLoading, error } = useQuery(
    'school-list',
    fetchSchoolList,
    {
      staleTime: 1000 * 60 * 10, // 10 mins cache
    }
  )

 const schoolName =
    data?.data?.school_name || 'School'

  return {
    schoolName,
    schoolData: data?.data || {},
    isLoading,
    error,
  }
}

export default useSchool